'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249 from "./presto.-Two-Factor-Auth-View$$anon$9.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024 from "./presto.-Two-Factor-Auth-View$-Seed-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
  this.bKY = null;
  this.bKQ = null;
  this.bKR = false;
  this.bKZ = null;
  this.bL0 = false;
  this.bL3 = null;
  this.bKW = null;
  this.bKX = false;
  this.bKS = null;
  this.bKT = false;
  this.bKU = null;
  this.bKV = false;
  this.bL1 = false;
  this.bL2 = false;
  this.bKY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bL3 = "SeedToken";
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bKY;
});
$p.M = (function() {
  if ((!this.bKR)) {
    this.bKQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bKR = true;
  }
  return this.bKQ;
});
$p.O = (function() {
  if ((!this.bL0)) {
    this.bKZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bL0 = true;
  }
  return this.bKZ;
});
$p.D = (function() {
  return this.bL3;
});
$p.t = (function() {
  if ((!this.bKX)) {
    this.bKW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bKX = true;
  }
  return this.bKW;
});
$p.N = (function() {
  if ((!this.bKT)) {
    this.bKS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bKT = true;
  }
  return this.bKS;
});
$p.Q = (function() {
  if ((!this.bKV)) {
    this.bKU = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249.$c_Lpresto_TwoFactorAuthView$$anon$9();
    this.bKV = true;
  }
  return this.bKU;
});
$p.v = (function() {
  if ((!this.bL2)) {
    this.bL1 = false;
    this.bL2 = true;
  }
  return this.bL1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee86) => ((p) => \u03b4scrutinee86.cHc(p)))($j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024.$m_Lpresto_TwoFactorAuthView$SeedToken$())));
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$8, "presto.TwoFactorAuthView$Tables$$anon$8", ({
  U1: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$8.js.map
